// src/pages/ForgotPassword.jsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../firebase";
import "../styles/Auth.css";
import AuthNav from "../components/AuthNav";
import { motion } from "framer-motion";

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  function handleSubmit(e) {
    e.preventDefault();
    setMessage("");
    setError("");

    if (!email) {
      setError("请输入邮箱地址 / Please enter your email.");
      return;
    }

    setSending(true);

    sendPasswordResetEmail(auth, email)
      .then(function () {
        setMessage(
          "重置密码邮件已发送，请检查邮箱（包括垃圾邮箱）。 / " +
            "Password reset email has been sent. Please check your inbox and spam folder."
        );
      })
      .catch(function (err) {
        console.error("sendPasswordResetEmail error:", err);
        var msg =
          "发送失败，请稍后再试。 / Failed to send reset email, please try again.";
        if (err && err.code === "auth/user-not-found") {
          msg =
            "未找到该邮箱对应的账号，请确认后再试。 / No user found with this email.";
        }
        setError(msg);
      })
      .finally(function () {
        setSending(false);
      });
  }

  return (
    <div className="auth-background">
      {/* 顶部导航（Members / Menu / Contact / About） */}
      <AuthNav />

      <motion.div
        className="auth-page-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -20 }}
        transition={{ duration: 0.16 }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "16px" }}>
          找回密码 / Forgot password
        </h2>

        <p
          style={{
            textAlign: "center",
            marginBottom: "20px",
            lineHeight: 1.6,
          }}
        >
          请输入注册时使用的邮箱，我们会发送一封重置密码邮件。<br />
          Please enter the email you used to register. We will send you a reset
          link.
        </p>

        <form className="auth-form" onSubmit={handleSubmit}>
          <label htmlFor="forgot-email">邮箱 / Email</label>
          <input
            id="forgot-email"
            type="email"
            value={email}
            onChange={function (e) {
              setEmail(e.target.value);
            }}
            placeholder="you@example.com"
          />

          <button type="submit" disabled={sending}>
            {sending ? "发送中..." : "发送重置邮件 / Send reset email"}
          </button>

          {error && <div className="error-message">{error}</div>}
          {message && <div className="success-message">{message}</div>}
        </form>

        <div style={{ marginTop: "16px", textAlign: "center" }}>
          <button
            type="button"
            className="linkButton"
            onClick={function () {
              navigate("/login");
            }}
          >
            返回登录 / Back to login
          </button>
        </div>
      </motion.div>
    </div>
  );
}

export default ForgotPassword;
